import api from '@/api/index.js'

const audit_logs = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_AUDIT_LOGS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_AUDIT_LOGS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_AUDIT_LOGS_ERROR: (state, error) => {
      state.error = error
    }
  },

  actions: {
    LoadAuditLogs({commit}, query) {
      commit('SET_AUDIT_LOGS', [])
      commit('SET_AUDIT_LOGS_ERROR', null)
      commit('SET_AUDIT_LOGS_LOADING', true)
      return api.get(`audit-logs?filter=${query.filter}&action_result=${query.action_result}&id=${query.id}&limit=${query.limit}&offset=0`)
        .then((response) => {
          commit('SET_AUDIT_LOGS', response)
        })
        .catch((error) => {
          commit('SET_AUDIT_LOGS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_AUDIT_LOGS_LOADING', false)
        })
    }
  }
}

export default audit_logs
